export default "__VITE_ASSET__MaKPrRvh__"